import { useSelector } from 'react-redux';
import {
  selectedGroupWithExtraDataOrderedSelector,
  selectedTeamWithExtraDataSelector
} from 'state/selectors/teams';
import { contributorsByIdSelector } from 'state/selectors/contributors';

const useGroupsTeam = () => {
  const contributorsById = useSelector(contributorsByIdSelector);
  const selectedGroup = useSelector(selectedTeamWithExtraDataSelector);
  const orderedSelectedGroup = useSelector(
    selectedGroupWithExtraDataOrderedSelector
  );

  const selectedGroupChildren = orderedSelectedGroup?.children || [];
  const selectedGroupChildrenIds =
    selectedGroupChildren.map(({ id }) => id) || [];
  const selectedGroupId = selectedGroup?.[0]?.id;

  return {
    selectedGroup,
    orderedSelectedGroup,
    contributorsById,
    selectedGroupChildren,
    selectedGroupChildrenIds,
    selectedGroupId
  };
};

export default useGroupsTeam;
